const isDev = process.env.NODE_ENV !== 'production';

export const CONSTANTS = {
    IS_DEV: isDev,
    LOCALE: 'sv-SE',
    EXTERNAL_USER_ID_PARAM: 'traderaUserId',
    CUSTOMER_SERVICE_USER_ID: 'CUSTOMER_SERVICE',
    ERRORS: {
        NOT_LOGGED_IN: 'NOT_LOGGED_IN',
        MEMBER_BLOCKED: 'ERROR_MEMBER_BLOCKED',
        BLOCKED_BY_MEMBER: 'ERROR_BLOCKED_BY_MEMBER',
        MEMBER_NOT_CONTACTABLE: 'ERROR_MEMBER_NOT_CONTACTABLE',
    },
    AUTH_STATE: {
        LOGGED_OUT: 'LOGGED_OUT',
        NOT_VERIFIED: 'NOT_VERIFIED',
        LOGGED_IN: 'LOGGED_IN',
    },
    FIREBASE: {
        CUSTOMER_SERVICE_ID: 'CUSTOMER_SERVICE',
        THREAD_STATE: {
            ACTIVE: 'ACTIVE',
            ACTIVE_LABEL: 'Till försäljning',
            ENDED: 'ENDED',
            ENDED_LABEL: 'Avslutad',
        },
        MESSAGE_PERMITION_TYPE: {
            ALLOWED: 'ALLOWED',
            ENDED: 'ENDED',
            BLOCKED: 'BLOCKED',
        },
        SUSPENDED_STATE: {
            NONE: 'NONE',
            PARTIAL: 'PARTIAL',
            TOTAL: 'TOTAL',
        },
        MESSAGE_TYPE: {
            IMAGE: 'IMAGE',
            TEXT: 'TEXT',
            CSTEXT: 'CSTEXT',
            WON: 'WON',
            PAID: 'PAID',
            SHIPPED: 'SHIPPED',
            COUNTER_OFFER_CREATED: 'COUNTER_OFFER_CREATED',
            COUNTER_OFFER_ACCEPTED: 'COUNTER_OFFER_ACCEPTED',
            COUNTER_OFFER_INVALIDATED_DUE_TO_DECLINED_BY_BUYER:
                'COUNTER_OFFER_INVALIDATED_DUE_TO_DECLINED_BY_BUYER',
            COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_MARKED_AS_UNAVAILABLE:
                'COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_MARKED_AS_UNAVAILABLE',
            COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_RESTARTED:
                'COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_RESTARTED',
            COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_BUY_IT_NOW:
                'COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_BUY_IT_NOW',
            COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_OTHER_OFFER:
                'COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_OTHER_OFFER',
            COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_CLOSED_BY_SELLER:
                'COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_CLOSED_BY_SELLER',
            COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_CLOSED_BY_SYSTEM:
                'COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_CLOSED_BY_SYSTEM',
            PURCHASE_OFFER_CREATED: 'PURCHASE_OFFER_CREATED',
            PURCHASE_OFFER_ACCEPTED: 'PURCHASE_OFFER_ACCEPTED',
            PURCHASE_OFFER_INVALIDATED_DUE_TO_DECLINED_BY_SELLER:
                'PURCHASE_OFFER_INVALIDATED_DUE_TO_DECLINED_BY_SELLER',
            PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_MARKED_AS_UNAVAILABLE:
                'PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_MARKED_AS_UNAVAILABLE',
            PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_RESTARTED:
                'PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_RESTARTED',
            PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_BUY_IT_NOW:
                'PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_BUY_IT_NOW',
            PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_OTHER_OFFER:
                'PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_OTHER_OFFER',
            PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_CLOSED_BY_SELLER:
                'PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_CLOSED_BY_SELLER',
            PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_CLOSED_BY_SYSTEM:
                'PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_CLOSED_BY_SYSTEM',
        },
    },
    CONVERSATION_STATE: {
        READING: 'READING',
        COMPOSE: 'COMPOSE',
        SELECT_IMAGE: 'SELECT_IMAGE',
        CONFIRM_ARCHIVE: 'CONFIRM_ARCHIVE',
    },
    REPORTING_USER_STATE: {
        NONE: 'NONE',
        SENDING: 'SENDING',
    },
    BLOCKING_USER_STATE: {
        NONE: 'NONE',
        SENDING: 'SENDING',
    },
    ADDING_MESSAGE_STATE: {
        NONE: 'NONE',
        SAVING: 'SAVING',
        ERROR: 'ERROR',
    },
    THREAD_FILTERS: {
        ALL: 'ALL',
        UNREAD: 'UNREAD',
        PURCHASE_OFFERS: 'PURCHASE_OFFERS',
        REMOVED: 'REMOVED',
    },
    THREAD_SORT_FIELDS: {
        ITEM_TITLE: 'ITEM_TITLE',
    },
    THREAD_SORT_ORDER: {
        ASC: 'ASC',
        DESC: 'DESC',
    },
    INIT_DATA: {
        isLoggedIn: true,
        title: `Tradera | Messenger ${
            isDev ? '|| Development Environment ||' : ''
        }`,
        hasSearch: true,
    },
    IMAGE_UPLOAD: {
        ALLOWED_TYPES: {
            'image/jpeg': 'jpg',
            'image/png': 'png',
            'image/gif': 'gif',
        },
        MAX_UPLOAD_FILE_SIZE: 25 * 1000 * 1000,
    },
    LISTING_ITEM_STATUS: {
        ACTIVE: 'ACTIVE',
    },
} as const;

export const AllPurchaseOfferMessageTypes: Partial<
    keyof typeof CONSTANTS.FIREBASE.MESSAGE_TYPE
>[] = [
    CONSTANTS.FIREBASE.MESSAGE_TYPE.PURCHASE_OFFER_CREATED,
    CONSTANTS.FIREBASE.MESSAGE_TYPE.PURCHASE_OFFER_ACCEPTED,
    CONSTANTS.FIREBASE.MESSAGE_TYPE
        .PURCHASE_OFFER_INVALIDATED_DUE_TO_DECLINED_BY_SELLER,
    CONSTANTS.FIREBASE.MESSAGE_TYPE
        .PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_MARKED_AS_UNAVAILABLE,
    CONSTANTS.FIREBASE.MESSAGE_TYPE
        .PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_RESTARTED,
    CONSTANTS.FIREBASE.MESSAGE_TYPE
        .PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_BUY_IT_NOW,
    CONSTANTS.FIREBASE.MESSAGE_TYPE
        .PURCHASE_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_OTHER_OFFER,
];

export const AllCounterOfferMessageTypes: Partial<
    keyof typeof CONSTANTS.FIREBASE.MESSAGE_TYPE
>[] = [
    CONSTANTS.FIREBASE.MESSAGE_TYPE.COUNTER_OFFER_CREATED,
    CONSTANTS.FIREBASE.MESSAGE_TYPE.COUNTER_OFFER_ACCEPTED,
    CONSTANTS.FIREBASE.MESSAGE_TYPE
        .COUNTER_OFFER_INVALIDATED_DUE_TO_DECLINED_BY_BUYER,
    CONSTANTS.FIREBASE.MESSAGE_TYPE
        .COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_MARKED_AS_UNAVAILABLE,
    CONSTANTS.FIREBASE.MESSAGE_TYPE
        .COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_RESTARTED,
    CONSTANTS.FIREBASE.MESSAGE_TYPE
        .COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_BUY_IT_NOW,
    CONSTANTS.FIREBASE.MESSAGE_TYPE
        .COUNTER_OFFER_INVALIDATED_DUE_TO_ITEM_SOLD_THROUGH_OTHER_OFFER,
];
